import { render, staticRenderFns } from "./bed.vue?vue&type=template&id=774f2ac2&scoped=true&"
import script from "./bed.vue?vue&type=script&lang=js&"
export * from "./bed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774f2ac2",
  null
  
)

export default component.exports